import { styled } from '@mui/material';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';

export const PageW = styled('div')`
  padding-left: 38px;
  display: flex;
  position: relative;
  flex-direction: column;
  padding-top: 64px;

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }

  @media (min-width: 1920px) {
    align-items: center;
  }
`;

export const ContentW = styled('div')<{ isPollPost?: boolean }>`
  width: 100%;
  width: 1065px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    min-width: 0px;
    width: 100%;
    align-self: stretch;
  }
`;

export const ContentWithRemoveW = styled('div')`
  display: flex;
  align-items: flex-start;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const MobileActionsW = styled('div')`
  display: none;

  @media (max-width: 1023px) {
    width: fit-content;
    display: flex;
  }
`;

export const RemoveIconW = styled(TrashIcon)`
  display: none;

  @media (max-width: 1023px) {
    display: block;
  }
`;
